// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__X2Bhn","consentsList":"PatientConsents_consentsList__C7GzW","consentsListEmpty":"PatientConsents_consentsListEmpty__QK4AM"};